module.exports = function () {
  return "<div class=\"poker-controls\" id=\"poker-controls\"><div class=\"status\" id=\"status\"></div><div class=\"poker-tray\" id=\"poker-control-row\"></div></div>";
};